import { useState, useEffect } from 'react';
import { X, Check, ChevronRight, CreditCard, Bell, Building2, Zap, ArrowRight, Clock, Package, Activity, Users, ShoppingCart, MessageCircle, Shield, Tag, EyeOff, Target, AlertTriangle, TrendingUp, Truck, DollarSign, Dna, BarChart3, Layers, RefreshCw, Search, FileText, Calendar, ClipboardList } from 'lucide-react';

// =============================================
// VERSİYON BİLGİSİ
// =============================================
export const APP_VERSION = "3.0210";
export const VERSION_DATE = "9 Şubat 2026";

export const RELEASE_NOTES = [
  {
    version: "3.0209",
    date: "9 Şubat 2026",
    title: "Cari İskontosu Otomatik · Çok Firmalı QNBPay & Dekont · WMS-CRM Köprüsü",
    subtitle: "Hızlı teklifte cari seçince iskonto otomatik uygulanır. KAYSERİ QNBPay altyapısı tam doğru firma bilgileriyle dekont yazıyor. WMS kullanıcılarına CRM görevlerim girişi geldi, Günaydın görev atamalarına detaylı ürün bilgisi eklendi.",
    sections: [
      {
        id: "cari-iskonto",
        title: "Hızlı/Teklif Sayfasında Müşteri İskontosu Otomatik",
        icon: Tag,
        color: "purple",
        isNew: true,
        features: [
          { text: "Cari seçildiğinde panel müşterisinin genel + grup bazlı (ITHAL %15, YETSAN %20 vb.) iskontoları satırlara otomatik uygulanır", important: true },
          { text: "Cari kartında müşterinin tüm iskontoları renkli rozetlerle görünür: 'Genel: %20 · ITHAL: %15 · YETSAN: %20'" },
          { text: "Yeni ürün eklendiğinde de o satıra cariye uygun iskonto anında uygulanır" },
          { text: "Manuel iskonto girilirse o satır kilitlenir ve sonraki cari değişikliklerinden etkilenmez" },
          { text: "Backend bulk SKU→groupCode lookup ile satırlardaki ürün grupları dakika dakika güncellenir" }
        ]
      },
      {
        id: "kayseri-qnbpay",
        title: "KAYSERİ QNBPay Tam Aktif + Doğru Firma Dekontu",
        icon: CreditCard,
        color: "blue",
        isNew: true,
        features: [
          { text: "KAYSERİ ödemelerinde dekontta artık doğru firma bilgisi yazıyor: KAYSERİ RADYATÖR OTO KALORİFER SAN.TİC.LTD.ŞTİ., MİMARSİNAN VERGİ DAİRESİ, V.No 5400601230", important: true },
          { text: "OTOMOTIV/KONYA/KAYSERI 3 firma için success/fail callback'leri panel.otoradyator.com altında doğru rotalanıyor" },
          { text: "Sistem Yönetimi → Banka & Ödeme: Firma Bilgileri kutusuna '🔄 Default'a Sıfırla' butonu (DB'deki eksik/stale firma bilgilerini siler, kod defaults'una düşürür)" },
          { text: "Firma bilgileri DB ile kod defaults'u deep-merge — kullanıcı override'ı korunur, eksikler default'tan tamamlanır" }
        ]
      },
      {
        id: "kk-provizyon-dekont",
        title: "Kredi Kartı Provizyon Dekontu Yenilendi",
        icon: FileText,
        color: "indigo",
        isNew: true,
        features: [
          { text: "Provizyon listesinden açılan dekont, ödemenin yapıldığı firmanın gerçek bilgilerini (unvan/adres/V.D./V.No) gösteriyor", important: true },
          { text: "Başarısız (FAIL) ödemelerin dekontu artık başarılı dekontla aynı A5 tasarıma sahip — firma başlığı, müşteri/işlem detayları, tutar kutusu, imza alanları" },
          { text: "Fail dekontunda kırmızı status banner + 'DENENEN TUTAR (Tahsil Edilemedi)' etiketi + ayrı hata açıklama kutusu" },
          { text: "Müşteri rolü için kompakt mobil uyumlu fail ekranı korundu" }
        ]
      },
      {
        id: "wms-crm",
        title: "WMS Anamenüye CRM Görevlerim Girişi",
        icon: ClipboardList,
        color: "cyan",
        isNew: true,
        features: [
          { text: "Sadece WMS modülünde çalışan kullanıcılar artık ana menüde 'CRM Görevlerim' kartını görür", important: true },
          { text: "Kartta kırmızı badge: bana atanmış tamamlanmamış görev sayısı (30 saniyede bir otomatik güncellenir, varsa pulse animasyon)" },
          { text: "Tıklayınca CRM Görevler sayfası 'Bana Atanan' tab'ı otomatik aktif gelir" },
          { text: "Hiçbir backend yetkilendirme değişikliği yapılmadı — mevcut CRM rol guard'ı korundu" }
        ]
      },
      {
        id: "gunaydin-urun",
        title: "Günaydın Dashboard Görev Atama: Ürün Bilgileri Zenginleştirme",
        icon: Package,
        color: "amber",
        isNew: true,
        features: [
          { text: "Günaydın'dan görev atandığında SKU üzerinden products koleksiyonundan ürün bilgileri otomatik çekilir: SKU, OEM, marka, boyut, özellikler (speCode1-5), barkod, kategori", important: true },
          { text: "Görev başlığında SKU + ürün adı: 'Ürün görseli temin — BPKRD52500054 OTOKAR KENT EURO6...'" },
          { text: "Görev açıklaması 8 satırlı ürün detay listesi olarak yazılır" },
          { text: "CRM Görevler sayfasında task kartında '📦 Ürün Bilgileri' rozeti — atanan kullanıcı ürünü tek bakışta tanır" }
        ]
      },
      {
        id: "mudur-fiyat",
        title: "Müdür Rolüne Fiyat Yönetimi Erişimi",
        icon: DollarSign,
        color: "emerald",
        isNew: false,
        features: [
          { text: "Müdür rolündeki kullanıcılar artık sidebar'da 'Fiyat Yönetimi' menüsünü görüyor" },
          { text: "Toplu fiyat geçmişi listesi ve detay görüntüleme açıldı" },
          { text: "Toplu rollback (yıkıcı işlem) hâlâ admin/superadmin'de kalır — güvenlik korundu" }
        ]
      }
    ],
    stats: { features: 23, improvements: 9, fixes: 6 }
  },
  {
    version: "3.0190",
    date: "15 Nisan 2026",
    title: "WMS Depo Transfer Akisi & Sistem Yonetimi Guclendirildi",
    subtitle: "Depo transfer sureci uctan uca iyilestirildi, irsaliye kontrolleri eklendi, takili islemler icin toplu zorla tamamlama ozelligi getirildi ve firma bazli erisim kisitlamalari guclendirildi.",
    sections: [
      {
        id: "depo-transfer",
        title: "Depo Transfer Akisi Yenilendi",
        icon: Truck,
        color: "blue",
        isNew: true,
        features: [
          { text: "Transfer talebi olusturulurken kargo firmasi bilgisi artik WMS kayitlarina dogru aktariliyor (ARAS, MNG, Yurtici vb.)", important: true },
          { text: "Transfer girisleri artik dogru yerde: /wms/ithalat-giris GIRIS tabinda gorunuyor (giris-fisleri sayfasindan tasindi)" },
          { text: "Cikis formu yazdirildiginda kargo firmasi mavi kutu icinde buyuk harflerle gorunuyor" },
          { text: "Kaynak firma (ornegin Kayseri) cikis irsaliyesini kesmemisse, hedef firma 'Kabul Et' yapamaz — 'KAYSERI IRSALIYE BEKLENIYOR' uyarisi gosterilir", important: true },
          { text: "GIRIS tabinda transfer satirlari renk kodlu: turuncu = irsaliye bekleniyor, yesil = irsaliye kesildi, kabul edilebilir" },
          { text: "Irsaliye kesilmemis transferlerde 'Kabul Et' butonu yerine 'Irsaliye Bekleniyor' etiketi gosterilir" },
          { text: "Cikis irsaliyesi tamamlandiginda, giris tarafindaki kayit otomatik guncellenir (irsaliye no ve tarih)" }
        ]
      },
      {
        id: "sistem-yonetimi",
        title: "Takili Islem Yonetimi (Sistem Yonetimi)",
        icon: AlertTriangle,
        color: "orange",
        isNew: true,
        features: [
          { text: "Siparis Duzeltme sekmesi artik TUM WMS tablolarini tariyor: orders, wms_bekleyen, wms_giris_fisleri, wms_cikis_fisleri, wms_ithalat_giris", important: true },
          { text: "Kaynak filtresi dropdown: Hangi tablodan gelen kayitlari gorecegini sec (orders, wms_bekleyen, wms_ithalat_giris vb.)" },
          { text: "Toplu secim: Checkbox ile birden fazla takili islemi sec, 'Secilenleri Zorla Tamamla' ile tek tusla hepsini bitir", important: true },
          { text: "Tek tikla tamamla: Her satirdaki onay butonuna tikla, onayla, aninda tamamlansin" },
          { text: "Her kayit hangi collection dan geldigini renk kodlu badge ile gosteriyor (mavi=orders, turuncu=wms_bekleyen, mor=wms_ithalat_giris)" },
          { text: "Zorla tamamlama artik MongoDB _id ile dogrudan ilgili kaydi buluyor — yanlis esleme riski sifir" }
        ]
      },
      {
        id: "cari-hesaplar",
        title: "Cari Hesaplar Iyilestirmeleri",
        icon: Users,
        color: "emerald",
        isNew: false,
        features: [
          { text: "Cari pasife alma artik dogru calisiyor — aktif listeden aninda duser, pasif listede gorunur", important: true },
          { text: "Arama yaparken aktif/pasif filtresi korunuyor (eski sorun: arama filreyi eziyordu)" },
          { text: "Logo ERP den gelen obje tipi veriler otomatik temizleniyor — 'Objects are not valid as React child' hatasi tamamen cozuldu" },
          { text: "Bacteria AI sekmesine 'Bacteria Analiz Baslat' butonu eklendi — CRM ye gitmeden dogrudan analiz baslatabilirsiniz", important: true },
          { text: "Cari bulunamadiginda detayli hata mesaji gosteriliyor (onceden sessizce basarisiz oluyordu)" }
        ]
      },
      {
        id: "firma-filtre",
        title: "Firma Bazli Erisim Kisitlamasi",
        icon: Shield,
        color: "red",
        isNew: true,
        features: [
          { text: "Admin ve mudur rolleri artik sadece kendi firmalarinin verilerini goruyor (sadece superadmin tum firmalara erisir)", important: true },
          { text: "Teklif listesinde firma filtresi token dan otomatik uygulanir — baska firmanin tekliflerini goremezsiniz" },
          { text: "Cari hesaplarda firma secimi kullanicinin kendi firmasina otomatik ayarlanir" },
          { text: "Siparis listesinde ayni kural gecerli — sadece kendi firmanizin siparislerini gorursunuz" }
        ]
      },
      {
        id: "teklif-tab",
        title: "Teklif Yonetimi & Tab Gecisleri",
        icon: FileText,
        color: "purple",
        isNew: false,
        features: [
          { text: "Teklif listesi 1000 sinirlamasindan kurtuldu — tum teklifler listelenir", important: true },
          { text: "Teklif ve Hizli Teklif sayfalarinda tab gecisleri duzeltildi — navigate() yerine openTab() kullaniliyor" },
          { text: "Teklif olusturup siparis ekranina gecerken tab sistemi dogru calisiyor" }
        ]
      },
      {
        id: "urun-karti",
        title: "Yeni Urun Karti (Logo ERP)",
        icon: Package,
        color: "blue",
        isNew: false,
        features: [
          { text: "Admin rolunde 'yetkiniz yok' hatasi duzeltildi — JWT token dogrulama paylasilan auth fonksiyonuna gecti" },
          { text: "Logo malzeme kartinda kullanim yerleri otomatik isaretleniyor: Malzeme Yonetimi, Satin Alma, Satis, Dagitim", important: true },
          { text: "Birimler sekmesinde cevrim katsayilari (CONVFACT1/CONVFACT2) otomatik 1 olarak ayarlaniyor — Logo kilitleme sorunu cozuldu" },
          { text: "ITMUNITA kaydi barkod olsun olmasin otomatik olusturuluyor" }
        ]
      }
    ],
    stats: { features: 32, improvements: 14, fixes: 12 }
  },
  {
    version: "3.0189",
    date: "10 Şubat 2026",
    title: "Bacteria AI ile Tanışın",
    subtitle: "Verileriniz artık sizin için konuşuyor. Bacteria AI, YETSAN'ın tüm satış, teklif ve müşteri verilerini analiz ederek size aksiyon odaklı öneriler sunar.",
    sections: [
      {
        id: "bacteria-nedir",
        title: "Bacteria AI Nedir?",
        icon: Dna,
        color: "purple",
        isNew: true,
        features: [
          { text: "Bacteria AI, YETSAN'ın yılların birikimiyle oluşan satış faturalarını, teklif geçmişini, müşteri hareketlerini ve stok verilerini derinlemesine analiz eden yapay zeka motorudur.", important: true },
          { text: "Siz satış yaparken Bacteria AI öğrendi. Hangi ürün ne zaman satılır, hangi müşteri ne ister, mevsimsel talepler nasıl değişir — tüm bu bilgiyi artık size geri sunuyor." },
          { text: "Verileriniz ne kadar zenginse, Bacteria AI o kadar isabetli çalışır. Her teklif, her sipariş, her fatura onu daha akıllı yapar." },
          { text: "Bacteria AI tamamen YETSAN'a özeldir. Sadece radyatör, kalorifer, kondenser, intercooler, evaporatör ve fan ürün grubunda çalışır — sektör dışı hiçbir öneri yapmaz." }
        ]
      },
      {
        id: "bacteria-urun",
        title: "Ürün Yönetimi'nde Bacteria AI",
        icon: BarChart3,
        color: "blue",
        isNew: true,
        features: [
          { text: "Her ürün satırında DNA simgesine mouse ile gelin — o ürünün tüm performans verileri anında karşınızda", important: true },
          { text: "Kaç kez teklif verilmiş, kaç sipariş alınmış, kaç kez aranmış — tek bakışta görün" },
          { text: "Logo ERP fatura verileri baz alınarak gerçek satış adetleri gösterilir (sipariş fişi değil, kesilmiş fatura)" },
          { text: "Mevsimsellik analizi: Ürünün en çok satıldığı ay ve dönem otomatik tespit edilir" },
          { text: "Admin ve üzeri roller 'Detaylı Bacteria Analiz' butonuna tıklayarak ürün için kapsamlı rapor alabilir" },
          { text: "Her analiz geçmişe kaydedilir (max 5). Önceki analizlerle karşılaştırma yapabilirsiniz" },
          { text: "Aynı ürüne gün içinde tekrar bakıldığında yeniden sorgu yapmaz — akıllı cache ile anında gelir" }
        ]
      },
      {
        id: "bacteria-siparis",
        title: "Yeni Sipariş'te Bacteria AI Önerileri",
        icon: ShoppingCart,
        color: "emerald",
        isNew: true,
        features: [
          { text: "Sipariş oluştururken sayfanın altında 'Bacteria AI Ürün Önerileri' paneli otomatik açılır", important: true },
          { text: "'Trend' sekmesi: Tüm firmalarda en çok sipariş edilen ve aranan ürünleri gösterir" },
          { text: "'Müşteriye Özel' sekmesi: Seçili müşterinin geçmiş alımlarına göre almadığı ama alması muhtemel ürünleri önerir", important: true },
          { text: "Mevsimsel öneriler öne çıkar — Kış aylarında kalorifer, yaz aylarında kondenser ürünleri vurgulanır" },
          { text: "Önerilen herhangi bir ürüne tıkladığınızda direkt sipariş satırlarına eklenir" },
          { text: "Ürün arama sonuçlarında da her SKU yanında Bacteria AI trend simgesi görünür" }
        ]
      },
      {
        id: "bacteria-crm",
        title: "CRM — Bacteria AI Müşteri Profilleme",
        icon: Users,
        color: "orange",
        isNew: true,
        features: [
          { text: "CRM Müşteri Detay sayfasında 'Bacteria Analiz' butonuna tıklayın — müşterinin 360 derece profilini çıkarır", important: true },
          { text: "Satın Alma Analizi: Hangi ürün tiplerini tercih ediyor (radyatör mü, kalorifer mi?), ne sıklıkta alıyor, hangi markalarda yoğunlaşmış, ortalama sepet tutarı ne kadar" },
          { text: "Mali Durum Raporu: Gerçek zamanlı borç durumu, ödeme disiplini (kaç gün geciktiriyor), vadesi geçmiş bakiye, risk seviyesi (Düşük/Orta/Yüksek)" },
          { text: "Sadakat Skoru: Müşteri ne zamandır sizinle çalışıyor, panel aktif mi, sipariş sıklığı düşüyor mu, rakibe kayma riski var mı" },
          { text: "Ölü Stok Önerileri: Depolarınızda bekleyen ama bu müşterinin alabileceği ürünleri tespit eder — hem siz stoktan kurtulur, hem müşteri ihtiyacını karşılar" },
          { text: "Risk & Fırsat Değerlendirmesi: Müşteriye daha fazla satış yapma fırsatları ve dikkat edilmesi gereken riskler tek cümlede özetlenir" },
          { text: "Her analiz tarihli olarak saklanır. Ay ay müşterinin değişimini takip edin — ödeme disiplini iyileşti mi, satın alma arttı mı?", important: true }
        ]
      },
      {
        id: "crm-musteri-detay",
        title: "CRM — Müşteri Detay Sayfası",
        icon: Activity,
        color: "blue",
        isNew: true,
        features: [
          { text: "Müşterinin tüm Logo ERP hesap hareketleri tek ekranda: Satış faturaları, tahsilatlar, borç/alacak dökümü", important: true },
          { text: "2025 ve 2026 mali dönem verileri birleşik gösterilir — geçmişe dönük tam görünüm" },
          { text: "Fatura detaylarına tıklayarak ürün bazında satışları inceleyin" },
          { text: "Cari bakiye, vadesi geçen borçlar ve risk limiti anlık güncellenir" },
          { text: "Teklif geçmişi: Müşteriye verilen tüm teklifler, durumları ve tutarları" },
          { text: "Müşteri notları: Ekip arkadaşlarınızın bıraktığı notları görün, yeni not ekleyin" }
        ]
      },
      {
        id: "crm-siparis-baglanti",
        title: "CRM ↔ Sipariş Bağlantısı",
        icon: ShoppingCart,
        color: "emerald",
        isNew: true,
        features: [
          { text: "Yeni Sipariş'te müşteri seçildiğinde CRM'deki son Bacteria analiz özeti otomatik gösterilir", important: true },
          { text: "Müşterinin puan, seviye (A+/A/B/C/D), risk durumu ve ödeme disiplini sipariş ekranında görünür" },
          { text: "Satın alma skoru, mali durum skoru ve sadakat skoru mini etiketlerle gösterilir" },
          { text: "Bacteria AI'ın önerdiği ürünler (CRM analizinden) sipariş ekranında tıklanabilir — doğrudan sipariş satırına ekleyin" },
          { text: "Analizi tekrar yapmaya gerek yok — CRM'de yapılan son analiz otomatik olarak sipariş tarafında kullanılır" }
        ]
      },
      {
        id: "bacteria-capraz",
        title: "Bacteria AI Çapraz Satış Motoru",
        icon: Target,
        color: "red",
        isNew: true,
        features: [
          { text: "Bacteria AI sadece YETSAN ürün grubundan çapraz satış önerir — radyatör alan müşteriye kalorifer, kondenser alan müşteriye intercooler gibi", important: true },
          { text: "Termostat, su pompası, hortum, kayış gibi YETSAN'ın üretmediği ürünler kesinlikle önerilmez" },
          { text: "Öneriler müşterinin geçmiş alımlarına ve mevsimsel talebe göre kişiselleştirilir" }
        ]
      },
      {
        id: "diger-iyilestirmeler",
        title: "Diğer İyileştirmeler",
        icon: Zap,
        color: "slate",
        isNew: false,
        features: [
          { text: "Tab sistemi güçlendirildi — firma/admin/müdür kullanıcılar artık tüm sayfalara sorunsuz erişir", important: true },
          { text: "Stok senkronizasyonu arka planda sessizce çalışır (3dk artımlı, gece tam sync)" },
          { text: "Logo ERP sorguları artık ana sistemi yavaşlatmaz — asenkron çalışır" },
          { text: "CRM'de hesap hareketleri 2025 ve 2026 verileri birleşik gösterilir" }
        ]
      }
    ],
    stats: { features: 45, improvements: 18, fixes: 8 }
  }
];

const COLORS = {
  blue: { 
    bg: 'bg-blue-50', 
    border: 'border-blue-100', 
    icon: 'bg-blue-600', 
    text: 'text-blue-700',
    badge: 'bg-blue-100 text-blue-700'
  },
  slate: { 
    bg: 'bg-slate-50', 
    border: 'border-slate-200', 
    icon: 'bg-slate-700', 
    text: 'text-slate-700',
    badge: 'bg-slate-100 text-slate-700'
  },
  emerald: { 
    bg: 'bg-emerald-50', 
    border: 'border-emerald-100', 
    icon: 'bg-emerald-600', 
    text: 'text-emerald-700',
    badge: 'bg-emerald-100 text-emerald-700'
  },
  purple: { 
    bg: 'bg-purple-50', 
    border: 'border-purple-100', 
    icon: 'bg-purple-600', 
    text: 'text-purple-700',
    badge: 'bg-purple-100 text-purple-700'
  },
  orange: { 
    bg: 'bg-orange-50', 
    border: 'border-orange-100', 
    icon: 'bg-orange-500', 
    text: 'text-orange-700',
    badge: 'bg-orange-100 text-orange-700'
  },
  red: { 
    bg: 'bg-red-50', 
    border: 'border-red-100', 
    icon: 'bg-red-600', 
    text: 'text-red-700',
    badge: 'bg-red-100 text-red-700'
  },
  green: { 
    bg: 'bg-green-50', 
    border: 'border-green-100', 
    icon: 'bg-green-600', 
    text: 'text-green-700',
    badge: 'bg-green-100 text-green-700'
  }
};

const UpdatePopup = ({ userRole }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  
  const release = RELEASE_NOTES[0];

  useEffect(() => {
    // Panel müşterilerine güncelleme popup'ı gösterme
    const musteriRolleri = ['musteri', 'client', 'firma_kullanicisi', 'firma'];
    if (musteriRolleri.includes(userRole)) {
      return;
    }
    
    const key = `update_${APP_VERSION}`;
    const count = parseInt(localStorage.getItem(key) || '0');
    if (count < 3) {
      localStorage.setItem(key, String(count + 1));
      setTimeout(() => setIsOpen(true), 100);
    }
  }, [userRole]);

  const toggleSection = (id) => {
    setExpandedSections(prev => ({ ...prev, [id]: !prev[id] }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden border border-slate-200">
        
        {/* Header - Kurumsal */}
        <div className="bg-slate-900 p-6 relative">
          <button 
            onClick={() => setIsOpen(false)} 
            className="absolute top-4 right-4 p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
          >
            <X size={18} />
          </button>
          
          <div className="flex items-start gap-4">
            {/* Logo/Icon */}
            <div className="w-14 h-14 bg-purple-600 rounded-xl flex items-center justify-center shadow-lg">
              <Dna size={28} className="text-white" />
            </div>
            
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-1">
                <h1 className="text-xl font-semibold text-white tracking-tight">
                  {release.title}
                </h1>
                <span className="px-2.5 py-1 bg-purple-500 text-white text-xs font-semibold rounded-md">
                  v{APP_VERSION}
                </span>
              </div>
              <p className="text-slate-400 text-sm">
                {release.subtitle?.split('.')[0] || 'Güncelleme detayları'}
              </p>
            </div>
          </div>
        </div>

        {/* Subtitle Bar */}
        <div className="px-6 py-3 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <Clock size={14} />
            <span>{release.date}</span>
            <span className="text-slate-300">•</span>
            <span>{release.subtitle}</span>
          </div>
          <div className="flex items-center gap-4 text-xs">
            <span className="text-slate-500">
              <span className="font-semibold text-slate-700">{release.stats.features}</span> özellik
            </span>
            <span className="text-slate-500">
              <span className="font-semibold text-slate-700">{release.stats.improvements}</span> iyileştirme
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 max-h-[45vh] overflow-y-auto">
          <div className="space-y-3">
            {release.sections.map((section) => {
              const Icon = section.icon;
              const color = COLORS[section.color] || COLORS.slate;
              const isExpanded = expandedSections[section.id] !== false; // Default açık
              
              return (
                <div 
                  key={section.id}
                  className={`border ${color.border} rounded-lg overflow-hidden transition-all ${color.bg}`}
                >
                  {/* Section Header */}
                  <div 
                    className="p-4 cursor-pointer select-none"
                    onClick={() => toggleSection(section.id)}
                  >
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 ${color.icon} rounded-lg flex items-center justify-center shadow-sm`}>
                        <Icon size={20} className="text-white" />
                      </div>
                      
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <h3 className="font-semibold text-slate-800">{section.title}</h3>
                          {section.isNew && (
                            <span className="px-2 py-0.5 bg-blue-600 text-white text-[10px] font-bold rounded uppercase tracking-wide">
                              Yeni
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-slate-500 mt-0.5">
                          {section.features.length} özellik
                        </p>
                      </div>
                      
                      <ChevronRight 
                        size={18} 
                        className={`text-slate-400 transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`} 
                      />
                    </div>
                  </div>
                  
                  {/* Section Content */}
                  {isExpanded && (
                    <div className="px-4 pb-4 pt-0">
                      <div className="pl-[52px] space-y-2">
                        {section.features.map((f, i) => (
                          <div key={i} className="flex items-start gap-2">
                            <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 mt-0.5 ${
                              f.important ? 'bg-emerald-100' : 'bg-slate-100'
                            }`}>
                              <Check size={12} className={f.important ? 'text-emerald-600' : 'text-slate-400'} />
                            </div>
                            <span className={`text-sm leading-relaxed ${
                              f.important ? 'text-slate-800 font-medium' : 'text-slate-600'
                            }`}>
                              {f.text}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
          <p className="text-xs text-slate-500">
            Sorularınız için destek ekibiyle iletişime geçebilirsiniz.
          </p>
          <button
            onClick={() => setIsOpen(false)}
            className="px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            Anladım
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePopup;
